import { render, staticRenderFns } from "./toasts.vue?vue&type=template&id=546d7a8e&scoped=true&"
import script from "./toasts.vue?vue&type=script&lang=ts&"
export * from "./toasts.vue?vue&type=script&lang=ts&"
import style0 from "./toasts.vue?vue&type=style&index=0&id=546d7a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d7a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546d7a8e')) {
      api.createRecord('546d7a8e', component.options)
    } else {
      api.reload('546d7a8e', component.options)
    }
    module.hot.accept("./toasts.vue?vue&type=template&id=546d7a8e&scoped=true&", function () {
      api.rerender('546d7a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "core/plugin/toasts/vue/toasts.vue"
export default component.exports